<script setup lang="ts">
import IconMakeFaceUpStar from '~/components/icons/responsible-gaming/IconFaceUpStar.vue'
import IconClockTime from '~/components/icons/responsible-gaming/IconClockTime.vue'
import IconSadFace from '~/components/icons/responsible-gaming/IconSadFace.vue'
import IconBrain from '~/components/icons/responsible-gaming/IconBrain.vue'

defineOptions({
	name: 'PillarsSection',
})

const { t: $t } = useI18n()
</script>

<template>
	<section class="bg-neutral-100 py-11 md:py-20 2xl:py-32">
		<div class="container space-y-12">
			<div class="text-center space-y-12">
				<h2 class="text-3xl sm:text-[40px] text-secondary-800 font-semibold leading-10 px-5 smm:px-0">
					{{ $t('Pillars of Responsible Playing') }}
				</h2>
				<p class="text-neutral-800 text-[18px] max-w-3xl mx-auto">
					{{
						$t(
							'To ensure that playing remains a fun activity, always remember these fundamental principles before you decide to play on any lottery site',
						)
					}}:
				</p>
			</div>
			<div class="xl:max-w-[958px] mx-auto space-y-9">
				<div class="flex flex-col sm:flex-row gap-9">
					<div class="bg-neutral-50 rounded-lg border border-neutral-200 p-8 space-y-8 sm:w-1/2 xl:w-full">
						<div class="bg-primary-50 size-20 rounded-xl flex items-center justify-center">
							<IconMakeFaceUpStar class="text-[#323232] shrink-0" />
						</div>
						<div class="space-y-2">
							<h3 class="text-[18px] font-semibold text-neutral-900 leading-6">
								{{ $t('Treat it as Entertainment, Not a Source of Income') }}
							</h3>
							<p class="text-neutral-700 text-sm leading-5">
								{{
									$t(
										'Lotteries are a form of entertainment, not a way to make a living or solve financial problems. The cost of a ticket is the price you pay for the fun and anticipation',
									)
								}}.
							</p>
						</div>
					</div>
					<div
						class="bg-neutral-50 rounded-lg border border-neutral-200 p-8 space-y-8 sm:w-1/2 xl:w-[426px] xl:shrink-0"
					>
						<div class="bg-primary-50 size-20 rounded-xl flex items-center justify-center">
							<IconClockTime class="text-[#323232] shrink-0" />
						</div>
						<div class="space-y-2">
							<h3 class="text-[18px] font-semibold text-neutral-900 leading-6">
								{{ $t('Set Clear Limits: Time and Money') }}
							</h3>
							<p class="text-neutral-700 text-sm leading-5">
								{{
									$t(
										'Before you play, decide how much money and time you are willing to spend. Only play with money you can afford to lose, without it affecting your responsibilities (like rent, bills, etc)',
									)
								}}.
							</p>
						</div>
					</div>
				</div>
				<div class="flex flex-col sm:flex-row gap-9">
					<div
						class="bg-neutral-50 rounded-lg border border-neutral-200 p-8 space-y-8 sm:w-1/2 xl:w-[422px] xl:shrink-0"
					>
						<div class="bg-primary-50 size-20 rounded-xl flex items-center justify-center">
							<IconSadFace class="text-[#323232] shrink-0" />
						</div>
						<div class="space-y-2">
							<h3 class="text-[18px] font-semibold text-neutral-900 leading-6">
								{{ $t('Never Chase Your Losses') }}
							</h3>
							<p class="text-neutral-700 text-sm leading-5">
								{{
									$t(
										`Accepting losses is part of playing. Trying to win back what you've lost by playing more is one of the most common signs of unhealthy playing habits`,
									)
								}}.
							</p>
						</div>
					</div>

					<div class="bg-neutral-50 rounded-lg border border-neutral-200 p-8 space-y-8 sm:w-1/2 xl:w-full">
						<div class="bg-primary-50 size-20 rounded-xl flex items-center justify-center">
							<IconBrain class="text-[#323232] shrink-0" />
						</div>
						<div class="space-y-2">
							<h3 class="text-[18px] font-semibold text-neutral-900 leading-6">{{ $t(`Understand the Odds`) }}</h3>
							<p class="text-neutral-700 text-sm leading-5">
								{{
									$t(
										`It's important to be realistic. The chances of winning major prizes are very small. Play for the thrill of the "what if," not with the expectation of winning`,
									)
								}}.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
